import React, { PureComponent } from "react";
import TwoColumnsLayout from "../../layouts/two-columns";
import AbbreviatedMillionNumberFormat from "../../../ui-building-blocks/numbers/AbbreviatedMillionNumberFormat";
import TypeformLink from "../../../typeform/link";
import TypeformUrls from "../../../typeform/TypeformUrls";
import IncomeStatementWidget from "../../../finance/widgets/income-statement";

class TeamReportsSection3Step4 extends PureComponent {
  get left_content() {
    const { netRevenues, netProfits } = this.props;

    return (
      <span>
        This is your Income Statement, which has 3 key sections:
        <br />
        <br />
        1. Gross Profits
        <br />
        2. Operating Profits
        <br />
        3. Net Profits
        <br />
        <br />
        You generated Net Revenues of{" "}
        <AbbreviatedMillionNumberFormat
          value={netRevenues}
          prefix="$"
          negativeClass="title-red"
          forceConvert={true}
        />{" "}
        and Net Profits of{" "}
        <AbbreviatedMillionNumberFormat
          value={netProfits}
          prefix="$"
          negativeClass="title-red"
          forceConvert={true}
        />
        .<br />
        Let's analyze each department's impact on the Income Statement!
        <br />
        <br />
        To learn more about FP&A, please view the following content
        <TypeformLink
          title="Financial Planning & Analysis"
          url={TypeformUrls.FINANCIAL_ANALYSIS}
          className="link-with-margin"
        />
      </span>
    );
  }

  get right_content() {
    const { incomeStatement, current_year } = this.props;

    return (
      <IncomeStatementWidget
        incomeStatement={incomeStatement}
        current_year={current_year}
      />
    );
  }

  render() {
    return (
      <TwoColumnsLayout
        title="Income Statement"
        left_content={this.left_content}
        right_content={this.right_content}
      />
    );
  }
}

export default TeamReportsSection3Step4;



// WEBPACK FOOTER //
// ./src/components/team-reports/steps/section-3/step-4.js